export default __webpack_public_path__ + "static/media/Linux_Logo.2ea04879.svg";